export const mutationKeysFactory =
  <T extends string>(context: T) =>
  <P extends string>(...key: P[]) =>
    [context, ...key] as [T, P];
